import { apiRequest } from "./api";

export type WorkAdjustmentType = "OVERTIME" | "HOLIDAY_WORK" | "HOLIDAY_OVERTIME";
export type WorkAdjustmentStatus = "PENDING" | "APPROVED" | "REJECTED";
export type HolidayType = "REGULAR_HOLIDAY" | "SPECIAL_NON_WORKING";

export interface WorkAdjustmentRequest {
  requestId: string;
  userId: string;
  businessId: string;
  employeeName?: string;
  type: WorkAdjustmentType;
  workDate: string;
  overtimeHours?: number;
  description: string;
  period: string;
  status: WorkAdjustmentStatus;
  holidayType?: HolidayType;
  reviewedBy?: string;
  reviewedAt?: string;
  rejectionReason?: string;
  payslipId?: string;
  createdAt: string;
  createdBy: string;
}

export interface ListWorkAdjustmentsResponse {
  items: WorkAdjustmentRequest[];
  nextKey?: string;
}

export const workAdjustmentApi = {
  // Employee
  submit: (businessId: string, body: {
    type: WorkAdjustmentType;
    workDate: string;
    overtimeHours?: number;
    description: string;
  }) =>
    apiRequest<WorkAdjustmentRequest>(`/biz/${businessId}/work-adjustments`, {
      method: "POST",
      body,
    }),

  listMine: (businessId: string, params?: { lastKey?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params?.lastKey) qs.set("lastKey", params.lastKey);
    if (params?.limit) qs.set("limit", String(params.limit));
    const query = qs.toString();
    return apiRequest<ListWorkAdjustmentsResponse>(
      `/biz/${businessId}/work-adjustments${query ? `?${query}` : ""}`,
    );
  },

  // Admin
  listAdmin: (businessId: string, params?: { status?: WorkAdjustmentStatus; lastKey?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params?.status) qs.set("status", params.status);
    if (params?.lastKey) qs.set("lastKey", params.lastKey);
    if (params?.limit) qs.set("limit", String(params.limit));
    const query = qs.toString();
    return apiRequest<ListWorkAdjustmentsResponse>(
      `/biz/${businessId}/admin/work-adjustments${query ? `?${query}` : ""}`,
    );
  },

  review: (
    businessId: string,
    userId: string,
    requestId: string,
    body: {
      action: "approve" | "reject";
      holidayType?: HolidayType;
      rejectionReason?: string;
    },
  ) =>
    apiRequest<{ success: boolean }>(
      `/biz/${businessId}/admin/work-adjustments/${userId}/${requestId}/review`,
      { method: "POST", body },
    ),
};
